import { render, staticRenderFns } from "./supervisor-layout.vue?vue&type=template&id=23528a72&"
import script from "./supervisor-layout.vue?vue&type=script&lang=js&"
export * from "./supervisor-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports